import { render, staticRenderFns } from "./sort.vue?vue&type=template&id=1522cb80&scoped=true&"
var script = {}
import style0 from "./sort.vue?vue&type=style&index=0&id=1522cb80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1522cb80",
  null
  
)

export default component.exports